
export const ROW_ACTION_TYPES = {
  CLICK_TRUE: 'CLICK_TRUE',
  CLICK_FALSE: 'CLICK_FALSE',
};
